var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-card',{staticStyle:{"border-radius":"12px"}},[_c('v-card-text',[_c('department-list')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }